import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

import { AppStrings } from "../../utils/constants/AppStrings";
import { getApiErrorMessage } from "../../utils/ErrorUtils";
import { bonusAdminEnvelope } from "./bonusAdminBody";
import { getCampaignQueryKey } from "./useGetCampaign";
import { LIST_CAMPAIGNS_QUERY_KEY } from "./useListCampaigns";

type StoredToken = { AccessToken?: string };
export type CampaignTransitionAction = "activate" | "pause" | "expire";

const ROUTE_MAP: Record<CampaignTransitionAction, string> = {
  activate: API_ROUTES.ACTIVATE_DYNAMIC_BONUS_CAMPAIGN,
  pause:    API_ROUTES.PAUSE_DYNAMIC_BONUS_CAMPAIGN,
  expire:   API_ROUTES.EXPIRE_DYNAMIC_BONUS_CAMPAIGN,
};

async function postTransition(
  campaignId: string,
  action: CampaignTransitionAction,
): Promise<string | undefined> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const url = ROUTE_MAP[action].replace("{campaign_id}", campaignId);
  const response = await instance.post(url);
  return bonusAdminEnvelope(response).message;
}

export const useCampaignTransition = (campaignId: string) => {
  const queryClient = useQueryClient();

  return useMutation<string | undefined, Error, CampaignTransitionAction>({
    mutationFn: (action) => postTransition(campaignId, action),
    onSuccess: (beMessage) => {
      queryClient.invalidateQueries({ queryKey: LIST_CAMPAIGNS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: getCampaignQueryKey(campaignId) });
      message.success(beMessage || AppStrings.PAM_GENERIC_REQUEST_SUCCEEDED);
    },
    onError: (error) => {
      message.error(getApiErrorMessage(error, AppStrings.PAM_GENERIC_REQUEST_FAILED));
    },
  });
};
